import { BREAKPOINTS } from "@carnet/ui/utils/breakpoints";

export const MOBILE_BREAKPOINT_PX = BREAKPOINTS.lg;

export const MOBILE_QUERY = `(max-width: ${MOBILE_BREAKPOINT_PX - 0.02}px)`;

export const SMALL_MOBILE_QUERY = `(max-width: ${BREAKPOINTS.sm - 0.02}px)`;
